import { zendeskArticleUrl } from "~/utils/zendesk";

export const ZENDESK_AI_ASSISTANT_HELP_URL = zendeskArticleUrl(
  "43511727336461-Getting-Started-with-AI"
);
export const ZENDESK_AI_SKILLS_URL = zendeskArticleUrl("43648526871437-AI-Skills-Guide");

export const isValidSharedConversationUrl = (url: string) =>
  /manifold\.ai\/shared\/conversations\//i.test(url);
